import React from 'react';
import { motion } from 'framer-motion';

export default function Terms() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="pt-32 pb-20"
    >
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Terms of Service</h1>

        <div className="prose prose-lg max-w-none">
          <p className="text-gray-600 mb-6">Last updated: December 2024</p>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Acceptance of Terms</h2>
            <p className="text-gray-600">
              By accessing or using DocumentAI.xyz, a service provided by Korcuda, you agree to be bound by these Terms of Service.
              If you do not agree to any part of the terms, you may not access or use the service.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Description of Service</h2>
            <p className="text-gray-600">
              DocumentAI.xyz provides a platform for document management, enabling users to scan, store, organize,
              and access their documents digitally. The service includes features such as document scanning, cloud
              storage, synchronization across devices, and access to advanced tools for document analysis.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. User Responsibilities</h2>
            <p className="text-gray-600 mb-4">As a user of DocumentAI.xyz, you agree to:</p>
            <ul className="list-disc pl-6 text-gray-600">
              <li>Provide accurate and complete information during the registration process</li>
              <li>Maintain the confidentiality of your account credentials</li>
              <li>Immediately notify us of any unauthorized use of your account</li>
              <li>Ensure that all content you upload complies with applicable laws and does not violate the rights of others</li>
              <li>Refrain from using the service for any unlawful or prohibited activities</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Prohibited Activities</h2>
            <p className="text-gray-600">
              Users are strictly prohibited from:
            </p>
            <ul className="list-disc pl-6 text-gray-600">
              <li>Using the service to distribute malicious software or engage in unauthorized access</li>
              <li>Reselling or sublicensing access to the service</li>
              <li>Uploading content that infringes on the intellectual property rights of others</li>
              <li>Interfering with or disrupting the operation of the service</li>
              <li>Attempting to reverse engineer or extract the source code of the platform</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Intellectual Property</h2>
            <p className="text-gray-600">
              All intellectual property rights in the service, including its design, features, and underlying technology,
              are owned by Korcuda. Users may not reproduce, distribute, or create derivative works based on the service
              without express written permission.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Termination of Service</h2>
            <p className="text-gray-600">
              DocumentAI.xyz reserves the right to suspend or terminate your access to the service at any time, with or
              without notice, if you violate these Terms of Service or engage in activities that harm the integrity
              of the platform or its users.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Limitation of Liability</h2>
            <p className="text-gray-600">
              To the maximum extent permitted by law, DocumentAI.xyz and Korcuda shall not be liable for any direct,
              indirect, incidental, or consequential damages resulting from your use of the service, including but not
              limited to loss of data, profits, or business opportunities.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Changes to Terms</h2>
            <p className="text-gray-600">
              We reserve the right to modify these Terms of Service at any time. Any changes will be posted on this
              page with an updated "Last updated" date. Your continued use of the service after changes are posted
              constitutes acceptance of the updated terms.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Governing Law</h2>
            <p className="text-gray-600">
              These Terms of Service are governed by the laws of the jurisdiction in which Korcuda is registered.
              Any disputes arising under these terms shall be resolved in accordance with the laws of that jurisdiction.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Contact Information</h2>
            <p className="text-gray-600">
              If you have any questions or concerns about these Terms of Service, please contact us at:
            </p>
            <p className="text-gray-600">
              <a href="mailto:legal@documentai.xyz" className="text-blue-600 hover:text-blue-700">
                legal@documentai.xyz
              </a>
            </p>
          </section>
        </div>
      </div>
    </motion.div>
  );
}
